export var IncentivesPermissionType;
(function (IncentivesPermissionType) {
    IncentivesPermissionType["VIEW"] = "view";
    IncentivesPermissionType["EDIT"] = "edit";
    IncentivesPermissionType["RUN"] = "run";
})(IncentivesPermissionType || (IncentivesPermissionType = {}));
//# sourceMappingURL=incentivesPermissionType.js.map